function checkNextPage(page = 0, total = 0, limit = 0) {
  return page * limit < total
}

export { checkNextPage }
